import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DOCUMENTS_API_V2 } from "./apiRoutes";

interface UseGetParkedDocByIdProps {
  communityId: string;
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getParkedDocById = async (communityId: string, id: string) =>
  await axiosAuth.get(`${DOCUMENTS_API_V2(communityId)}/parked/${id}`);

const useGetParkedDocById = ({
  communityId,
  id,
  queryParams,
}: UseGetParkedDocByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["parked-doc-by-id", id],
    queryFn: () => getParkedDocById(communityId, id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetParkedDocById;
